import { Typography } from '@navi/web-ui/lib/primitives';
import { AUDIT_ICON_MAP } from '../../utils';

const PrefilledTag = ({
  preAuditDoneBy,
  preAuditText
}: {
  preAuditDoneBy: string;
  preAuditText: string;
}) => {
  return (
    <div className="w-fit flex flex-row gap-1 border-[1px] border-dotted border-[var(--greyscale-light)] rounded-md px-[6px] py-[2px] bg-[var(--bg-primary-warm)]">
      {AUDIT_ICON_MAP[preAuditDoneBy]}
      <Typography variant="p5" color="var(--grayscale-2)">
        {preAuditText}
      </Typography>
    </div>
  );
};

export default PrefilledTag;
